/**
 * @fileoverview Helper functions for using SelectFeatures in the Taskflow.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {SelectFeatures} from '/src/com/yext/listingslaunchstorm/js/enterprise/selectfeatures/selectfeatures';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {Task} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/task';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';

import * as styles from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/taskflow.module.scss';
import BookSvg from '/src/com/yext/listingslaunchstorm/public/icons/book.svg';
import ListingsLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/listings-large.svg';

export const SelectFeaturesTask = new Task({
  id: TaskIds.SELECT_FEATURES,

  getPage: (enterpriseConfiguration, setEnterpriseConfiguration, pageControls) => ({
    id: TaskIds.SELECT_FEATURES,
    layoutHeader: {
      icon: (<ListingsLargeSvg />),
      title: yext.msg('Select Features'),
      description: yext.msg('Set which features to launch on your Listings by assigning licenses to your entities. All features are selected by default unless you do not have enough licenses.'),
      resourceLink: {
        src: 'https://help.yext.com/hc/en-us/articles/15771112366619-Automatically-Assign-Licenses-to-Entities-Using-a-Saved-Filter',
        external: true,
        displayText: yext.msg('Learn About Assigning Licenses'),
        icon: (<BookSvg />),
      },
    },
    // The Select Features task is invalid without a previous entity selection
    content: enterpriseConfiguration.entitySelection && (
      <SelectFeatures
        selection={enterpriseConfiguration.featureSelection}
        onChangeSelection={featureSelection => setEnterpriseConfiguration(
          new EnterpriseConfiguration({...enterpriseConfiguration, featureSelection}),
        )}
        entitySelection={enterpriseConfiguration.entitySelection}
      />
    ),
  }),

  getCard: (enterpriseConfiguration, index, selectedPageId, setSelectedPageId, disabled) => ({
    id: TaskIds.SELECT_FEATURES,
    title: yext.msg('Select Features'),
    index,
    isSelected: (selectedPageId === TaskIds.SELECT_FEATURES),
    onClick: disabled ? undefined : () => setSelectedPageId(TaskIds.SELECT_FEATURES),
    content: getCardContent(enterpriseConfiguration),
  }),

  isComplete: enterpriseConfiguration => (!!enterpriseConfiguration.featureSelection?.ids.length),
  isSectionSkipped: enterpriseConfiguration => !!enterpriseConfiguration?.featureSelection?.skipSetup,
});

/**
 * @param {EnterpriseConfiguration} enterpriseConfiguration
 * @returns {React.ReactNode}
 */
function getCardContent(enterpriseConfiguration) {
  const selection = enterpriseConfiguration.featureSelection;
  const skipSetup = selection?.skipSetup;

  if (!selection || skipSetup) {
    return undefined;
  } else {
    return (
      <div className={styles.cardContent}>
        {selection.displayNames.join(', ')}
      </div>
    );
  }
}
